import React from "react";
import { Col, Container, Row } from "reactstrap";
import { connect } from "react-redux";
import { useTranslation } from "react-i18next";
import { ParticipantTabNavs } from "@/shared/components/tabNavs";
import Sidebar from "@/containers/Layout/sidebar";
import ClearPageLayout from "@/containers/Participant/components/ClearPageLayout";
import Leaderboards from "./components/Leaderboards";

const CLASSIC_IMG_BACK = `${process.env.PUBLIC_URL}/theme/classic/img/pages/my-points.jpg`;

const LeaderboardPage = ({ template }) => {
  const { t } = useTranslation();

  const LeaderboardClear = () => (
    <div className="lb-page">
      <div className="lb-page__header">
        <Container>
          <div className="lb-page__header-inner">
            <div>
              <h1 className="lb-page__title">{t("leaderboards")}</h1>
            </div>
          </div>
        </Container>
      </div>

      <Container className="lb-page__body">
        <ClearPageLayout>
          <Leaderboards />
        </ClearPageLayout>
      </Container>
    </div>
  );

  const LeaderboardClassic = () => (
    <>
      <div className="mainboard">
        <img src={CLASSIC_IMG_BACK} alt={t("leaderboards")} />
        <div className="title">{t("leaderboards")}</div>
      </div>

      <Container>
        <ParticipantTabNavs />
      </Container>

      <Container>
        <Row>
          <Col md={9}>
            <div className="dashboard">
              <Leaderboards />
            </div>
          </Col>
          <Col md={3}>
            <Sidebar />
          </Col>
        </Row>
      </Container>
    </>
  );

  return (
    (template?.name === "clear" && <LeaderboardClear />) ||
    (template?.name === "classic" && <LeaderboardClassic />) || <LeaderboardClear />
  );
};

const mapStateToProps = (state) => ({
  template: state.template,
});

export default connect(mapStateToProps)(LeaderboardPage);
